module.exports = __webpack_public_path__ + "img/ucenter-bg.947da135.png";